import { Backdrop, Grid } from "@material-ui/core";
import OrderProcessingView, {
  OrderProcessStatus
} from "@saleor/apps/components/OrderProcessing";
import {
  getNetPriceForProductGroup1,
  getNetPriceForProductGroup2
} from "@saleor/changeOrderDomestic/utils";
import DialogConfirmChangeOrder from "@saleor/changeOrderExport/components/DialogConfirmChangeOrder/DialogConfirmChangeOrder";
import { TypeConfirm } from "@saleor/changeOrderExport/views/ViewEditOrder/types";
import AppHeader from "@saleor/components/AppHeader";
import Container from "@saleor/components/Container";
import DialogConfirmDelete from "@saleor/components/DialogConfirmDelete";
import DialogConfirmError from "@saleor/components/DialogConfirmError";
import DialogProcessing from "@saleor/components/DialogProcessing";
import MyTypography from "@saleor/components/MyTypography";
import PageHeader from "@saleor/components/PageHeader";
import Skeleton from "@saleor/components/Skeleton";
import SnackbarAlert from "@saleor/components/SnackbarAlert";
import { Tab, TabContainer } from "@saleor/components/Tab";
import TimeOutPage from "@saleor/components/TimeOutPage";
import { defaultListSettings, STAFF_UPDATE } from "@saleor/config";
import {
  checkIsCashSaleOrder,
  prepareCashSalePayload
} from "@saleor/createOrChangeNotRefContract/utils";
import useCashSaleForm from "@saleor/createOrder/components/CashSaleForm/useCashSaleForm";
import {
  orderCartlUrl,
  previewOrderPath,
  shoppingCart
} from "@saleor/createOrder/urls";
import BottomBarCreateOrder from "@saleor/createOrderDomestic/components/BottomBar";
import DrawAddProductDomestic from "@saleor/createOrderDomestic/components/DrawAddProductDomestic";
import HeaderTabView from "@saleor/createOrderDomestic/components/HeaderTab";
import ItemDetailsTab, {
  ItemDetailsTabRef,
  ItemTab
} from "@saleor/createOrderDomestic/components/ItemDetailsTab";
import {
  contractDetaiUrlParamTab,
  DomesticOrderQueryParams,
  DomesticOrderSortField
} from "@saleor/createOrderDomestic/urls";
import { getRealTimePartnerDataByType } from "@saleor/createOrderDomestic/utils";
import { ContentHeaderTab } from "@saleor/createOrderDomestic/views/CreateOrderView/const";
import { ChangeOrderCSTab } from "@saleor/createOrderDomestic/views/CreateOrderView/types";
import useSales from "@saleor/createOrderDomestic/views/CreateOrderView/useSales";
import DialogError from "@saleor/createOrderExport/components/DialogError";
import {
  OrderType,
  RealtimePartnerType,
  ScgOrderStatus,
  useCartTotalCheckoutQuery,
  useContractLazyQuery,
  useContractOrderDomesticQuery,
  useDeleteContractOrderLinesDomesticMutation,
  useGet_Realtime_PartnerMutation,
  useGetArOutstandingQuery,
  useSubmitCashSaleMutation,
  useUpdateContractOrderDomesticMutation,
  useUpdateOrderLinesDomesticMutation
} from "@saleor/graphql";
import useAppState from "@saleor/hooks/useAppState";
import useBulkActions from "@saleor/hooks/useBulkActions";
import useListSettings from "@saleor/hooks/useListSettings";
import useNavigator from "@saleor/hooks/useNavigator";
import useNotifier from "@saleor/hooks/useNotifier";
import usePaginationLocal from "@saleor/hooks/usePaginationLocal";
import { makeStyles } from "@saleor/macaw-ui";
import { ListViews } from "@saleor/types";
import { PROD_CATEG_1, PROD_CATEG_2 } from "@saleor/utils/constants";
import { getPreviousDate, parseDateString } from "@saleor/utils/date";
import { getRandomNumber } from "@saleor/utils/getRandowNumber";
import createSortHandler from "@saleor/utils/handlers/sortHandler";
import {
  calculateNewTotalWeightCommon,
  roundDecimal
} from "@saleor/utils/number";
import { getSortParams, getSortUrlVariables } from "@saleor/utils/sort";
import { buildUrl } from "@saleor/utils/urls";
import { setNestedObjectValues, useFormik } from "formik";
import React, {
  ReactNode,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState
} from "react";
import { useIntl } from "react-intl";
import * as Yup from "yup";

export interface CreateOrderViewProps {
  id: string;
  params: DomesticOrderQueryParams;
}

interface StyleProps {
  fullScreen?: boolean;
}

interface ModalConfirm {
  title: ReactNode | string;
  content: ReactNode | string;
  type: TypeConfirm;
}

const HeaderTab = Tab(ChangeOrderCSTab.header);
const ItemDetailTab = Tab(ChangeOrderCSTab.itemDetails);

const useStyles = makeStyles<StyleProps>(
  theme => ({
    pageHeader: {
      marginBottom: "1.2rem",
      "& > :first-child": {
        visibility: props => (props.fullScreen ? "hidden" : "visible"),
        margin: 0,
        marginBottom: props => (props.fullScreen ? "0.4rem" : "1.2rem")
      },
      "& > :nth-child(2)": {
        alignSelf: "flex-end"
      }
    },
    boxContainer: {
      paddingBottom: "20rem"
    },
    tab: {
      padding: "10px 0",
      textAlign: "center"
    },
    tabBox: {
      "&>span:first-child": {
        borderRadius: "12px 0 0 0"
      },
      "&>span:last-child": {
        borderRadius: "0 12px 0 0"
      }
    },
    titleDelete: {
      color: theme.palette.error.light
    },
    snackHeadTitle: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      columnGap: "1.2rem"
    },
    backDrop: {
      zIndex: 1399
    },
    boxInfo: {
      marginTop: "3rem"
    },
    SoNo: {
      color: theme.palette.info.main
    },
    alignRight: {
      textAlign: "right"
    },
    titleMain: {
      color: theme.palette.info.main
    }
  }),
  { name: "OrdersViewDomestic" }
);

export enum TypeOfApplyAll {
  Successfully = "success",
  UnSuccessfully = "error"
}

export enum ModeUpdate {
  ApplyAll = "apply_all",
  SaveDraft = "save_draft",
  AutoSaveDraft = "auto_save_draft",
  Submit = "submit"
}

const CreateOrderDomesticView: React.FC<CreateOrderViewProps> = ({
  id,
  params
}) => {
  const intl = useIntl();
  const navigate = useNavigator();
  const [{ fullScreen }] = useAppState();
  const classes = useStyles({ fullScreen });
  const [orderProcessStatus, setOrderProcessStatus] = useState<
    OrderProcessStatus
  >(OrderProcessStatus.inconclusive);
  const [orderProcessError, setOrderProcessError] = useState("");
  const [errorCode, setErrorCode] = useState("");
  const [isSuccessfully, setSuccessfully] = useState<TypeOfApplyAll | null>(
    null
  );
  const [mode, setMode] = useState<ModeUpdate | null>(null);
  const [billToInsteaded, setBillToInsteaded] = useState<string>("");
  const [shipToInsteaded, setShipToInsteaded] = useState<string>("");

  const notify = useNotifier();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [openConfirmOrder, setOpenConfirmOrder] = useState<boolean>(false);
  const [visibleDialogError, setVisibleDialogError] = useState<boolean>(false);
  const [dataModalConfirm, setDataModalConfirm] = useState<ModalConfirm>({
    type: undefined,
    content: undefined,
    title: undefined
  });
  const [activeTab, setActiveTab] = useState<ChangeOrderCSTab>(
    ChangeOrderCSTab.header
  );
  const [activeTabHeader, setActiveTabHeader] = useState<ContentHeaderTab>(
    ContentHeaderTab.partner
  );
  const [componentKey, setComponentKey] = useState<number>(0);
  const [toogleDraft, setToogleDraft] = useState(0);
  const [openDelete, setOpenDelete] = useState<boolean>(false);
  const {
    isSelected: isSelectDelete,
    listElements: listSelectDelete,
    reset: resetDelete,
    toggle: toggleDelete,
    set: setDelete
  } = useBulkActions([]);

  const [dialogError, setDialogError] = useState(false);
  const [errorSource, setErrorSource] = useState("");
  const [errorOrders, setErrorOrders] = useState([]);
  const [errorItems, setErrorItems] = useState([]);
  const [isDisabledSubmit, setDisabledSubmit] = useState<boolean>(false);

  const [popUpContent, setPopUpContent] = useState(null);

  // START pagination setting
  const [listOrderLine, setListOrderLine] = useState([]);
  const { updateListSettings, settings } = useListSettings(
    ListViews.CREATE_ORDER_DOMESTIC_LIST
  );

  const itemDetailsTabRef = useRef<ItemDetailsTabRef>(null);

  const {
    data: cartInfoData,
    refetch: reFetchCart
  } = useCartTotalCheckoutQuery({
    skip: true
  });

  const [, dispatchAppState] = useAppState();
  useEffect(() => {
    if (cartInfoData) {
      const orderCount =
        cartInfoData.totalContractCheckouts?.totalProducts || 0;
      dispatchAppState({
        payload: {
          orderCount
        },
        type: "setOrderCount"
      });
    }
  }, [cartInfoData]);

  useEffect(() => {
    updateListSettings(
      "rowNumber",
      defaultListSettings.CREATE_ORDER_DOMESTIC_LIST.rowNumber
    );
  }, []);

  const {
    data: dataOrderList,
    loading: loadingOrderDomesticList,
    refetch: reFetchOrderList
  } = useContractOrderDomesticQuery({
    skip: !id,
    variables: {
      soNo: id
    },
    fetchPolicy: "no-cache"
  });

  const taxPercent = useMemo(
    () => dataOrderList?.contractOrder?.taxPercent || 0,
    [dataOrderList]
  );

  const dataTabHeader = dataOrderList;
  const loadingTabHeader = loadingOrderDomesticList;
  const isCashSaleOrder = checkIsCashSaleOrder(
    dataOrderList?.contractOrder?.orderType
  );

  useEffect(() => {
    if (dataOrderList) {
      setListOrderLine(
        dataOrderList?.contractOrder?.orderLines.map(line => {
          const clone = {
            errorQuantity: false,
            ...line
          };
          return clone;
        })
      );
    }
  }, [dataOrderList]);

  const ItemTabSchema = Yup.object().shape({
    lines: Yup.array().of(
      Yup.object().shape({
        remain: Yup.number(),
        quantity: Yup.number().required("โปรดระบุจำนวนที่ต้องการ"),
        errorQuantity: Yup.boolean().oneOf(
          [false],
          "จำนวนที่สั่งมีมากกว่าจำนวนคงเหลือ"
        ),
        requestDate: Yup.date()
          .transform(parseDateString)
          .min(
            getPreviousDate(),
            "กรุณาเปลี่ยน “Request Date” (ไม่สามารถใส่วันที่ผ่านมาแล้วได้)"
          )
          .typeError(" ")
          .required(" ")
      })
    )
  });

  const convertOrderLinesToFormik = line => {
    const rootUnit = line?.weightUnit;
    return {
      ...line,
      id: line.id,
      itemNo: line.itemNo,
      quantity: line.quantity,
      remain: line.contractProduct?.remain || 0,
      plant: line.plant,
      requestDate: line.requestDate || "",
      inquiryMethodCode: line.inquiryMethod,
      internalCommentsToWarehouse: line?.internalCommentsToWarehouse,
      productInformation: line?.productInformation,
      externalCommentsToCustomer: line?.externalCommentsToCustomer,
      internalCommentsToLogistic: line?.internalCommentsToLogistic,
      shipTo: line?.shipTo || "",

      rootUnit,
      weightUnit: line.weightUnit,
      weight: calculateNewTotalWeightCommon(
        line?.quantity,
        line.weight,
        line.weightUnit,
        rootUnit
      ),
      weightPerUnit: line?.weight,
      price: line?.contractProduct?.price,
      variantId: line?.variant?.id,
      errorQuantity: line.errorQuantity,
      currency: line?.contractProduct?.currency || ""
    };
  };

  const formikItemTab = useFormik({
    enableReinitialize: true,
    validationSchema: ItemTabSchema,
    initialValues: {
      lines: listOrderLine?.map(line => convertOrderLinesToFormik(line)) || []
    },
    validateOnMount: true,
    onSubmit: () => null
  });

  const {
    currentData,
    next,
    prev,
    toFirst,
    toLast,
    disableNext,
    disablePrev
  } = usePaginationLocal(formikItemTab.values.lines, settings.rowNumber);

  const lastPaginationState = () => {
    toLast();
    setComponentKey(componentKey + 1);
  };

  const handlePreviousFirstPage = () => {
    toFirst();
    setComponentKey(componentKey + 1);
  };

  const handleNextLastPage = () => {
    lastPaginationState();
  };

  const handlePreviousPage = () => {
    prev();
    setComponentKey(componentKey + 1);
  };

  const handleNextPage = () => {
    next();
    setComponentKey(componentKey + 1);
  };

  const handleSort = field => {
    toFirst();
    const sortParam = getSortUrlVariables(field, params);
    const lines = [...formikItemTab.values.lines];
    switch (sortParam.sort) {
      case DomesticOrderSortField.item_no:
        if (sortParam.asc) {
          lines.sort(
            (itemA, itemB) => Number(itemA.itemNo) - Number(itemB.itemNo)
          );
        } else {
          lines.sort(
            (itemA, itemB) => Number(itemB.itemNo) - Number(itemA.itemNo)
          );
        }
        break;
      default:
        break;
    }
    formikItemTab.setFieldValue("lines", lines);
    navigate(
      orderCartlUrl(id, {
        ...getSortUrlVariables(field, params)
      }),
      { replace: true }
    );
  };

  useEffect(() => {
    toFirst();
  }, [settings?.rowNumber]);
  // END pagination setting

  // Modal Add Product
  const [getDataContract, { data: dataContract }] = useContractLazyQuery({
    fetchPolicy: "no-cache"
  });

  useEffect(() => {
    if (dataTabHeader?.contractOrder?.contract?.id) {
      getDataContract({
        variables: {
          id: dataTabHeader?.contractOrder?.contract?.id
        }
      });
    }
  }, [dataTabHeader?.contractOrder?.contract?.id]);

  const handleAddItems = () => {
    setIsPopupOpen(prev => !prev);
    getDataContract({
      variables: {
        id: dataTabHeader?.contractOrder?.contract?.id
      }
    });
  };

  const handleClosePopup = () => {
    setIsPopupOpen(false);
  };

  const handleSortListProduct = createSortHandler(
    navigate,
    contractDetaiUrlParamTab(id),
    params
  );

  const handleAddMoreData = data => {
    const dataConvert = data.map(item => convertOrderLinesToFormik(item));
    formikItemTab.setValues(values => ({
      lines: [...values.lines, ...dataConvert]
    }));
  };
  // END handle modal add product

  const [applyAllOrderLinesDomestic] = useUpdateOrderLinesDomesticMutation({
    onError: () => {
      setSuccessfully(TypeOfApplyAll.UnSuccessfully);
    },
    onCompleted: data => {
      if (!data?.updateOrderLines?.errors?.length) {
        setSuccessfully(TypeOfApplyAll.Successfully);
        formikItemTab.setValues(values => ({
          lines: values.lines.map(line => ({
            ...line,
            requestDate:
              data?.updateOrderLines?.order?.orderLines?.[0]?.requestDate ||
              getDataFromFormikHeader()?.requestDate
          }))
        }));
      }
    }
  });

  const [saveDraftWhenSubmit] = useUpdateContractOrderDomesticMutation({
    onError: () => {
      setDisabledSubmit(false);
    },
    onCompleted: () => {
      setDisabledSubmit(false);
    }
  });
  const [updateOrderLinesDomestic] = useUpdateContractOrderDomesticMutation({
    onError: error => {
      setDisabledSubmit(false);
      if (error?.message?.includes("Read timed out")) {
        setOrderProcessStatus(OrderProcessStatus.timeOut);
        return;
      }
      if (mode === ModeUpdate.Submit) {
        setMode(null);
        setOrderProcessStatus(OrderProcessStatus.failed);
        notify({
          status: "error",
          apiMessage: error.message
        });
      }
    },
    onCompleted: async data => {
      setDisabledSubmit(false);
      reFetchCart();
      if (data?.updateContractOrder?.success) {
        const params: Record<string, string> = {};

        if (mode === ModeUpdate.SaveDraft) {
          setSuccessfully(TypeOfApplyAll.Successfully);
          return;
        } else if (mode === ModeUpdate.AutoSaveDraft) {
          return;
        } else if (mode === ModeUpdate.Submit) {
          if (isCashSaleOrder) {
            const orderId = dataOrderList?.contractOrder?.id;
            const cashSaleStatus = await handleSubmitCashSaleCreate(orderId);
            params.cashSaleStatus = cashSaleStatus;
          }

          const warningMessages = data?.updateContractOrder?.warningMessages;
          const eOrderWarnings = data?.updateContractOrder?.eorWarnings;
          // Handle eOrderWarnings
          if (eOrderWarnings?.length) {
            let eOrderWarning = "";
            eOrderWarnings.forEach(({ message }) => {
              eOrderWarning += `${message}\n`;
            });

            notify({
              title: "Warning E-Ordering",
              status: "warning",
              text: (
                <>
                  <div>
                    <p style={{ padding: "16px 12px" }}>{eOrderWarning}</p>
                  </div>
                </>
              ),
              autohide: null
            });
          }
          if (warningMessages?.length) {
            let sapOrderWraning = "";
            warningMessages.forEach(({ order, message }) => {
              sapOrderWraning += `${order} - ${message}\n`;
            });

            notify({
              title: "Warning SAP",
              status: "warning",
              apiMessage: sapOrderWraning,
              autohide: null
            });
          }

          if (data?.updateContractOrder?.iPlanMessages?.length > 0) {
            const iplanErrList = data?.updateContractOrder?.iPlanMessages?.map(
              item => `${item.firstCode}${item.secondCode} - ${item.message}`
            );

            notify({
              status: "error",
              sourceSystem: "IPLAN",
              apiMessage: iplanErrList.join("\n")
            });
          }

          navigate(buildUrl(previewOrderPath(id), params));
          return;
        } else {
          return;
        }
      } else {
        if (mode === ModeUpdate.Submit) {
          setOrderProcessStatus(OrderProcessStatus.inconclusive);
          setMode(null);
          if (
            data?.updateContractOrder?.sapOrderMessages?.length > 0 ||
            data?.updateContractOrder?.sapItemMessages?.length > 0
          ) {
            const sapErrorOrders =
              data?.updateContractOrder?.sapOrderMessages?.map(
                ({ errorCode, errorMessage }) =>
                  `${errorCode} - ${errorMessage}`
              ) || [];

            const sapErrorItems =
              data?.updateContractOrder?.sapItemMessages?.map(
                ({ itemNo, errorCode, errorMessage }) => ({
                  itemNo,
                  itemCode: errorCode,
                  itemStatus: errorMessage
                })
              ) || [];

            setDialogError(true);
            setErrorSource("SAP");
            setErrorOrders(sapErrorOrders);
            setErrorItems(sapErrorItems);
          } else if (data?.updateContractOrder?.iPlanMessages?.length > 0) {
            const iplanErrorItems = data?.updateContractOrder?.iPlanMessages?.map(
              item => ({
                itemNo: item.itemNo,
                itemCode: `${item.firstCode}${item.secondCode}`,
                itemStatus: item.message
              })
            );

            setDialogError(true);
            setErrorSource("IPLAN");
            setErrorItems(iplanErrorItems);
          } else {
            setOrderProcessStatus(OrderProcessStatus.failed);
            let sapOrderErrors = "";
            let errorCodes = "";
            // eslint-disable-next-line chai-friendly/no-unused-expressions
            data?.updateContractOrder?.errors?.length &&
              data?.updateContractOrder?.errors?.forEach(
                ({ message, code }) => {
                  sapOrderErrors += `${message} \n`;
                  errorCodes = code;
                }
              );

            setOrderProcessError(sapOrderErrors);
            setErrorCode(errorCodes);
          }
        }
      }
    }
  });

  const [submitCashSaleCreate] = useSubmitCashSaleMutation();

  const wrapperSaveDraftWhenSubmit = () => {
    setDisabledSubmit(true);
    return saveDraftWhenSubmit;
  };
  const wrapperUpdateOrderLinesDomestic = () => {
    setDisabledSubmit(true);
    return updateOrderLinesDomestic;
  };
  const contract = dataTabHeader?.contractOrder?.contract;

  const renderAddress = () =>
    dataTabHeader?.contractOrder?.customer?.representatives[0]?.addresses?.map(
      add => `${add.streetAddress1}, ${add.streetAddress2}`
    ) || [];

  const addressesShipTo =
    useMemo(() => {
      const contractDetail = dataTabHeader?.contractOrder?.contract;
      const list = renderAddress();
      if (!list.includes(contractDetail?.shipTo) && contractDetail?.shipTo) {
        list.push(contractDetail?.shipTo);
      }
      return list;
    }, [dataTabHeader]) || [];

  // const addressesBillTo =
  //   useMemo(() => {
  //     const contractDetail = dataTabHeader?.contractOrder?.contract;
  //     const list = renderAddress();
  //     if (!list.includes(contractDetail?.billTo) && contractDetail?.billTo) {
  //       list.push(contractDetail?.billTo);
  //     }
  //     return list;
  //   }, [dataTabHeader]) || [];

  const textError = intl.formatMessage({ defaultMessage: "โปรดระบุข้อมูล" });
  const textDateError = intl.formatMessage({
    defaultMessage:
      "กรุณาเปลี่ยน “Request Date” (ไม่สามารถใส่วันที่ผ่านมาแล้วได้)"
  });

  const HeaderTabSchema = Yup.object().shape({
    shipTo: Yup.string().required(),
    billTo: Yup.string().required(),
    salesOrganization: Yup.string().required(),
    salesGroup: Yup.string().required(),
    salesOffice: Yup.string().required(),
    distributionChannel: Yup.string().required(),
    division: Yup.string().required(),
    poNo: Yup.string().required(textError),
    requestDate: Yup.date()
      .transform(parseDateString)
      .typeError(textError)
      .min(getPreviousDate(), textDateError)
      .required(textError)
  });

  const contractDetail = dataTabHeader?.contractOrder?.contract;
  const orderDetail = dataTabHeader?.contractOrder;

  const [
    saleGroupChoices,
    divisionChoices,
    saleOfficeChoices,
    distributionChannelChoices,
    saleOrganizationChoices
  ] = useSales(orderDetail?.saleOrganization?.code);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      poDate: orderDetail?.poDate || "",
      poNo: orderDetail?.poNumber || "",
      requestDate: orderDetail?.requestDate,

      billTo: orderDetail?.billTo || "",
      shipTo: orderDetail?.shipTo || "",
      externalCommentsToCustomer: orderDetail?.externalCommentsToCustomer || "",
      productInformation: orderDetail?.productInformation || "",
      internalCommentsToWarehouse:
        orderDetail?.internalCommentsToWarehouse || "",
      internalCommentsToLogistic: orderDetail?.internalCommentsToLogistic,

      salesGroup: orderDetail?.saleGroup?.id || saleGroupChoices[0]?.value,
      salesOffice: orderDetail?.saleOffice?.id || saleOfficeChoices[0]?.value,
      salesOrganization:
        orderDetail?.saleOrganization?.id || saleOrganizationChoices[0]?.value,
      distributionChannel:
        orderDetail?.distributionChannel?.id ||
        distributionChannelChoices[0]?.value,
      division: orderDetail?.division?.id || divisionChoices[0]?.value
    },
    validationSchema: HeaderTabSchema,
    onSubmit: () => {
      //
    }
  });

  const getDataFromFormikHeader = () => ({
    requestDate: formik.values.requestDate,
    shipTo: formik.values.shipTo || "",
    billTo: formik.values.billTo || "",
    externalCommentsToCustomer: formik.values.externalCommentsToCustomer || "",
    productInformation: formik.values.productInformation || "",
    internalCommentsToWarehouse:
      formik.values.internalCommentsToWarehouse || "",
    internalCommentsToLogistic: formik.values.internalCommentsToLogistic || ""
  });

  const arOutstandingResult = useGetArOutstandingQuery({
    fetchPolicy: "no-cache",
    variables: {
      input: {
        saleOrgCode: orderDetail?.saleOrganization?.code,
        soldToCode: contractDetail?.customer?.soldToCode
      }
    },
    skip:
      !isCashSaleOrder ||
      !orderDetail?.saleOrganization?.code ||
      !contractDetail?.customer?.soldToCode
  });

  const handleOnDelete = () => {
    setOpenDelete(true);
  };

  const handleOnSaveDraft = () => {
    setMode(ModeUpdate.SaveDraft);
    wrapperUpdateOrderLinesDomestic()({
      variables: getDataFromFormik(ScgOrderStatus.DRAFT)
    });
  };

  const getDataFromFormik = useCallback(
    (status: ScgOrderStatus) => {
      const dataHeaderTab = formik.values;
      return {
        id,
        input: {
          status,
          lines: formikItemTab.values.lines.map(line => ({
            id: line.id,
            itemNo: line.itemNo,
            shipTo: line.shipTo || undefined,
            requestDate: line.requestDate || undefined,
            externalCommentsToCustomer: line?.externalCommentsToCustomer || "",
            shippingMark: line?.shippingMark || "",
            unit: line?.unit || "",
            materialNo: line?.variant?.code || "",
            internalCommentsToLogistic: line?.internalCommentsToLogistic || "",
            internalCommentsToWarehouse: line.internalCommentsToWarehouse || "",
            productInformation: line.productInformation || "",
            plant: line.plant || "",
            quantity: line.quantity || undefined,
            variantId: line.variantId || undefined
          })),
          orderInformation: {
            poNumber: dataHeaderTab.poNo || undefined,
            poDate: dataHeaderTab.poDate || undefined,
            internalCommentsToWarehouse:
              dataHeaderTab.internalCommentsToWarehouse || "",
            internalCommentsToLogistic:
              dataHeaderTab.internalCommentsToLogistic || "",
            externalCommentsToCustomer:
              dataHeaderTab.externalCommentsToCustomer || "",
            productInformation: dataHeaderTab.productInformation || "",
            orderType: dataOrderList?.contractOrder?.orderType || null,
            requestDate: dataHeaderTab.requestDate || null,
            shipTo: dataHeaderTab.shipTo || undefined,
            billTo: dataHeaderTab.billTo || undefined,
            customerId: dataTabHeader?.contractOrder?.customer?.id || undefined
          },
          orderOrganizationData: {
            distributionChannelId:
              dataHeaderTab.distributionChannel || undefined,
            saleOrganizationId: dataHeaderTab.salesOrganization || undefined,
            divisionId: dataHeaderTab.division || undefined,
            saleGroupId: dataHeaderTab.salesGroup || undefined,
            saleOfficeId: dataHeaderTab.salesOffice || undefined
          }
        }
      };
    },
    [formik.values, formikItemTab]
  );

  // Auto save draft order every 5 minutes
  useEffect(() => {
    const intervalId = setInterval(() => {
      setToogleDraft(toogleDraft + 1);
    }, 1000 * 60 * 5);
    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    if (
      toogleDraft &&
      mode !== ModeUpdate.Submit &&
      !isDisabledSubmit &&
      ![
        OrderProcessStatus.success,
        OrderProcessStatus.failed,
        OrderProcessStatus.block,
        OrderProcessStatus.timeOut
      ].includes(orderProcessStatus)
    ) {
      setMode(ModeUpdate.AutoSaveDraft);
      wrapperUpdateOrderLinesDomestic()({
        variables: getDataFromFormik(ScgOrderStatus.DRAFT)
      });
    }
  }, [toogleDraft]);

  const handleOnSaveDraftWhenSubmit = () => {
    wrapperSaveDraftWhenSubmit()({
      variables: getDataFromFormik(ScgOrderStatus.DRAFT)
    });
  };

  const shouldShowCashSaleWarningBeforeSave = () =>
    isCashSaleOrder &&
    !cashSaleFormProps.formik?.values?.cashFlag &&
    !cashSaleFormProps.formik?.values?.balanceFlag;

  const handleOnSubmitOrder = async () => {
    setMode(ModeUpdate.Submit);
    handleOnSaveDraftWhenSubmit();

    const errors = await formik.validateForm();
    if (Object.keys(errors).length > 0) {
      dispatchAppState({
        payload: { value: false },
        type: "setFullScreen"
      });
      setVisibleDialogError(true);
      formik.setTouched(setNestedObjectValues(errors, true));
      setActiveTabHeader(ContentHeaderTab.partner);
      setActiveTab(ChangeOrderCSTab.header);
      return;
    }

    const itemErrors = await formikItemTab.validateForm();
    if (Object.keys(itemErrors).length > 0) {
      dispatchAppState({
        payload: { value: false },
        type: "setFullScreen"
      });
      setVisibleDialogError(true);
      formikItemTab.setTouched(setNestedObjectValues(itemErrors, true));
      setActiveTab(ChangeOrderCSTab.itemDetails);
      setTimeout(() =>
        itemDetailsTabRef?.current?.forceChangeTab(ItemTab.tabA)
      );
      return;
    }

    if (isCashSaleOrder) {
      const cashSaleErrors = await cashSaleFormProps.formik.validateForm();
      if (Object.keys(cashSaleErrors).length > 0) {
        dispatchAppState({
          payload: { value: false },
          type: "setFullScreen"
        });
        setVisibleDialogError(true);
        cashSaleFormProps.formik.setTouched(
          setNestedObjectValues(cashSaleErrors, true)
        );
        changeToCashSaleTab();
        return;
      }
    }

    let title = "ยืนยันคำสั่งซื้อ";
    let content =
      "กรุณากด “ยืนยัน” เพื่อสร้างคำสั่งซื้อ หรือกด “กลับไป” เพื่อปิดหน้าต่างนี้";

    if (shouldShowCashSaleWarningBeforeSave()) {
      title = "คุณยังไม่ได้ระบุ “จำนวนเงินโอน” หรือ “เงินเหลือที่ต้องการใช้”";
      content =
        "คุณสามารถกด “ยืนยัน” เพื่อสร้างคำสั่งซื้อ หรือกด “กลับไป” เพื่อปิดหน้าต่างนี้";
    }

    setDataModalConfirm({
      title: (
        <span className={classes.titleMain}>
          {intl.formatMessage({
            defaultMessage: title
          })}
        </span>
      ),
      content: intl.formatMessage({
        defaultMessage: content
      }),
      type: TypeConfirm.SUBMIT
    });
    handleOpenConfirm();
  };

  const handleOnApplyAll = () => {
    formik.validateForm().then(errors => {
      if (!errors.poNo && !errors.requestDate) {
        applyAllOrderLinesDomestic({
          variables: {
            id,
            input: {
              ...getDataFromFormikHeader(),
              shippingPoint: "",
              route: ""
            }
          }
        });
      } else {
        formik.setTouched(setNestedObjectValues(errors, true));
        setActiveTabHeader(ContentHeaderTab.partner);
      }
    });
    setMode(ModeUpdate.ApplyAll);
  };

  const handleBack = () => {
    setDataModalConfirm({
      content: intl.formatMessage({
        defaultMessage:
          "กรุณากด “ยืนยัน” เพื่อยกเลิกการแก้ไขคำสั่งซื้อ หรือกด “กลับไป” เพื่อปิดหน้าต่างนี้"
      }),
      title: intl.formatMessage({ defaultMessage: "ยกเลิกการแก้ไขคำสั่งซื้อ" }),
      type: TypeConfirm.CANCEL
    });
    handleOpenConfirm();
  };

  const handleOpenConfirm = () => {
    setOpenConfirmOrder(true);
  };

  const [
    deleteDomesticOrderLines,
    { loading: loadingDeleteDomesticOrderLines }
  ] = useDeleteContractOrderLinesDomesticMutation({
    onCompleted: data => {
      const errors = data?.deleteContractOrderLines?.errors;
      if (errors.length === 0) {
        const length =
          formikItemTab.values.lines.length - listSelectDelete.length;
        let countDesc = 10 * (length + 1);
        let countAsc = 0;
        const isDescItemNo =
          params.sort === DomesticOrderSortField.item_no && !params.asc;
        formikItemTab.setValues(values => ({
          lines: values.lines
            .filter(line => !listSelectDelete.includes(line.id))
            .map(lineItem => ({
              ...lineItem,
              itemNo: isDescItemNo ? (countDesc -= 10) : (countAsc += 10)
            }))
        }));
        handlePreviousFirstPage();
        resetDelete();
      }
    }
  });

  const deleteOrderLines = () => {
    deleteDomesticOrderLines({
      variables: {
        ids: listSelectDelete
      }
    });
    setOpenDelete(false);
  };

  const handleCloseConfirm = () => {
    setDataModalConfirm({
      content: undefined,
      title: undefined,
      type: undefined
    });
    setOpenConfirmOrder(false);

    if (shouldShowCashSaleWarningBeforeSave()) {
      changeToCashSaleTab();
    }
  };

  const changeToCashSaleTab = () => {
    cashSaleFormProps.preventCashAmountAutoFillOnNextMount();
    setActiveTab(ChangeOrderCSTab.itemDetails);
    setTimeout(() => itemDetailsTabRef?.current?.forceChangeTab(ItemTab.tabD));
  };

  const handleConfirmOrder = () => {
    if (dataModalConfirm.type === TypeConfirm.SUBMIT) {
      setOrderProcessStatus(OrderProcessStatus.success);
      wrapperUpdateOrderLinesDomestic()({
        variables: getDataFromFormik(ScgOrderStatus.CONFIRMED)
      });
    } else if (dataModalConfirm.type === TypeConfirm.CANCEL) {
      navigate(shoppingCart);
    }
    handleCloseConfirm();
  };

  const onTabClick = tab => {
    setActiveTab(tab);
  };

  const calculateNetPrice = (quantity, price, weightPerUnit, prcGroup1) => {
    if (PROD_CATEG_1(prcGroup1)) {
      return getNetPriceForProductGroup1(quantity, price, weightPerUnit);
    } else if (PROD_CATEG_2(prcGroup1)) {
      return getNetPriceForProductGroup2(quantity, price);
    }
  };

  const getPriceData = () => {
    let netPrice = 0;
    const list = formikItemTab.values.lines ?? [];
    list.forEach(line => {
      netPrice += calculateNetPrice(
        line.quantity,
        line.price,
        line.weightPerUnit,
        line.prcGroup1
      );
    });
    const vat = netPrice * taxPercent;
    const totalPrice = netPrice + vat;
    return {
      itemCount: currentData()?.length || 0,
      netPrice,
      vat,
      totalPrice,
      usd: dataOrderList?.contractOrder?.contract?.currency
    };
  };

  const priceData = {
    itemCount: formikItemTab?.values?.lines?.length || 0,
    totalPrice: getPriceData().totalPrice || 0,
    vat: getPriceData().vat || 0,
    netPrice: getPriceData().netPrice || 0,
    usd: getPriceData().usd || ""
  };

  const cashSaleFormProps = useCashSaleForm({
    isEditable: true,
    orderAmount: roundDecimal(priceData.totalPrice, 2),
    arOutstandingResult
  });

  const handleSubmitCashSaleCreate = async (orderId: string) => {
    const formikCashSale = cashSaleFormProps?.formik;
    const payload = prepareCashSalePayload(orderId, formikCashSale);
    const { data } = await submitCashSaleCreate(payload);
    return data?.submitCashSale?.cashSaleStatus;
  };

  const handleProcessCreateOrderFailed = () => {
    setOrderProcessStatus(OrderProcessStatus.inconclusive);
  };

  const [
    getRealtimePartnerData,
    { data: realtimePartnerData, loading: loadingRealtimePartner }
  ] = useGet_Realtime_PartnerMutation({
    variables: {
      type: [RealtimePartnerType.SHIP_TO, RealtimePartnerType.BILL_TO],
      saleOrgCode: dataOrderList?.contractOrder?.saleOrganization?.code || "",
      soldToCode: dataOrderList?.contractOrder?.customer?.code,
      piMessageId: getRandomNumber(),
      distributionChannel:
        dataOrderList?.contractOrder?.distributionChannel?.code,
      division: dataOrderList?.contractOrder?.division?.code,
      orderType: OrderType.DOMESTIC
    }
  });

  const addressesBillTo =
    useMemo(() => {
      const realtimePartnerDataBill = getRealTimePartnerDataByType(
        RealtimePartnerType.BILL_TO,
        realtimePartnerData
      );
      const billToText = realtimePartnerDataBill?.[0]?.displayText;
      const list = renderAddress();

      if (!list.includes(billToText) && billToText) {
        list.push(billToText);
      }
      return list;
    }, [realtimePartnerData]) || [];

  useEffect(() => {
    if (dataOrderList?.contractOrder) {
      getRealtimePartnerData();
    }
  }, [dataOrderList, dataOrderList?.contractOrder?.saleOrganization]);

  const remainProductInOrderLinesCateg1 = useMemo(() => {
    const newList = [...formikItemTab.values.lines];
    const calculator = {};
    newList.forEach(line => {
      const total = calculator[line.contractProduct.id];
      if (total) {
        calculator[line.contractProduct.id] =
          total + Number(line.quantity || 0) * Number(line.variant.weight || 0);
      } else {
        calculator[line.contractProduct.id] =
          Number(line.quantity || 0) * Number(line.variant.weight || 0);
      }
    });
    return calculator;
  }, [formikItemTab?.values?.lines]);

  const remainProductInOrderLines = useMemo(() => {
    const newList = [...formikItemTab.values.lines];
    const calculator = {};
    newList.forEach(line => {
      const total = calculator[line.contractProduct.id];
      if (total) {
        calculator[line.contractProduct.id] =
          total + Number(line.quantity || 0);
      } else {
        calculator[line.contractProduct.id] = Number(line.quantity || 0);
      }
    });
    return calculator;
  }, [formikItemTab?.values?.lines]);

  if (orderProcessStatus === OrderProcessStatus.timeOut) {
    return (
      <TimeOutPage
        timeOutText={
          <>
            <MyTypography variant={"body2"}>
              กรุณาตรวจสอบคำสั่งซื้อที่เมนู Inquiry - Order Confirmation
            </MyTypography>
            <MyTypography variant={"body2"}>
              หากไม่พบคำสั่งซึ้อ กรุณาติดต่อ Customer Services: (02-586-5555 กด
              11)
            </MyTypography>
          </>
        }
      />
    );
  }

  if (params.enabledCreate !== "true") {
    return (
      <OrderProcessingView
        orderProcessStatus={OrderProcessStatus.block}
        onFailed={null}
      />
    );
  }

  return (
    <>
      {orderProcessStatus === OrderProcessStatus.inconclusive ? (
        <>
          <Container className={classes.boxContainer}>
            {!fullScreen && (
              <>
                <PageHeader
                  className={classes.pageHeader}
                  title={"สร้างคำสั่งซื้อ"}
                />
                <AppHeader onBack={handleBack}>
                  <MyTypography variant="body3">
                    {intl.formatMessage({ defaultMessage: "กลับไป" })}
                  </MyTypography>
                </AppHeader>
                <TabContainer>
                  <div className={classes.tabBox}>
                    <HeaderTab
                      testId="header-tab"
                      isActive={activeTab === ChangeOrderCSTab.header}
                      changeTab={onTabClick}
                    >
                      <MyTypography variant="h6" className={classes.tab}>
                        {intl.formatMessage({
                          defaultMessage: "Header",
                          description: "subtitle"
                        })}
                      </MyTypography>
                    </HeaderTab>
                    <ItemDetailTab
                      testId="item-details-tab"
                      isActive={activeTab === ChangeOrderCSTab.itemDetails}
                      changeTab={onTabClick}
                    >
                      <MyTypography variant="h6" className={classes.tab}>
                        {intl.formatMessage({
                          defaultMessage: "Item Details",
                          description: "subtitle"
                        })}
                      </MyTypography>
                    </ItemDetailTab>
                  </div>
                </TabContainer>
              </>
            )}
            <Grid container spacing={2} className={classes.boxInfo}>
              <Grid item xs={12} md={5}>
                <Grid container spacing={2}>
                  <Grid item md={2}>
                    <MyTypography variant={"subtitle3"}>
                      Contract No.
                    </MyTypography>
                  </Grid>
                  <Grid item md={10}>
                    <MyTypography variant={"body3"}>
                      {/* loadingTabHeader */}
                      {loadingRealtimePartner && loadingTabHeader ? (
                        <Skeleton />
                      ) : contract ? (
                        `${contract?.contractNo} ${
                          contract.projectName
                            ? `- ${contract?.projectName}`
                            : ""
                        }`
                      ) : (
                        <Skeleton />
                      )}
                    </MyTypography>
                  </Grid>
                  <Grid item md={2}>
                    <MyTypography variant={"subtitle3"}>
                      Sold-to Party
                    </MyTypography>
                  </Grid>
                  <Grid item md={10}>
                    <MyTypography variant={"body3"}>
                      {loadingRealtimePartner && loadingTabHeader ? (
                        <Skeleton />
                      ) : dataTabHeader ? (
                        `${dataTabHeader?.contractOrder?.customer?.soldToCode} - ${dataTabHeader?.contractOrder?.customer?.soldToName}`
                      ) : (
                        <Skeleton />
                      )}
                    </MyTypography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} md={5}>
                <Grid container spacing={2}>
                  <Grid item md={3}>
                    <MyTypography variant={"subtitle3"}>
                      Ship-to Party
                    </MyTypography>
                  </Grid>
                  <Grid item md={9}>
                    <MyTypography variant={"body3"}>
                      {loadingRealtimePartner && loadingTabHeader ? (
                        <Skeleton />
                      ) : contractDetail ? (
                        shipToInsteaded?.split("\n")[0] ||
                        orderDetail?.shipTo?.split("\n")[0] ||
                        ""
                      ) : (
                        <Skeleton />
                      )}
                    </MyTypography>
                  </Grid>
                  <Grid item md={3}>
                    <MyTypography variant={"subtitle3"}>
                      Bill-to Party
                    </MyTypography>
                  </Grid>
                  <Grid item md={9}>
                    <MyTypography variant={"body3"}>
                      {loadingRealtimePartner && loadingTabHeader ? (
                        <Skeleton />
                      ) : (
                        billToInsteaded?.split("\n")[0] ||
                        orderDetail?.billTo?.split("\n")[0] || <Skeleton />
                      )}
                    </MyTypography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            <div
              hidden={activeTab !== ChangeOrderCSTab.header}
              data-testid="header-tab-container"
            >
              <HeaderTabView
                getRealtimePartnerData={getRealtimePartnerData}
                realtimePartnerData={realtimePartnerData}
                activeTab={activeTabHeader}
                setActiveTab={setActiveTabHeader}
                setBillToInsteaded={setBillToInsteaded}
                setShipToInsteaded={setShipToInsteaded}
                formik={formik}
                dataContract={dataContract}
                data={dataTabHeader?.contractOrder}
                contract={dataOrderList}
                key={`header_${componentKey}`}
                addressShipTo={addressesShipTo}
                addressBillTo={addressesBillTo}
                salesOrgCode={orderDetail?.saleOrganization?.code}
                onApplyAll={handleOnApplyAll}
              />
            </div>

            <div
              hidden={activeTab !== ChangeOrderCSTab.itemDetails}
              data-testid="item-details-tab-container"
            >
              <ItemDetailsTab
                ref={itemDetailsTabRef}
                getRealtimePartnerData={getRealtimePartnerData}
                realtimePartnerData={realtimePartnerData}
                currency={dataOrderList?.contractOrder?.contract?.currency}
                currentTab={activeTab}
                addressShipTo={addressesShipTo}
                isSelectDelete={isSelectDelete}
                listSelectDelete={listSelectDelete}
                setDelete={setDelete}
                resetDelete={resetDelete}
                toggleDelete={toggleDelete}
                formik={formikItemTab}
                key={`material_${componentKey}`}
                reFetchOrderList={reFetchOrderList}
                onPreviousFirstPage={handlePreviousFirstPage}
                onNextLastPage={handleNextLastPage}
                disabled={loadingOrderDomesticList}
                latestPageItemNumber={
                  dataOrderList?.contractOrder?.orderLines?.length
                }
                onNextPage={handleNextPage}
                onPreviousPage={handlePreviousPage}
                onRowClick={() => null}
                onSort={handleSort}
                totalCount={
                  dataOrderList?.contractOrder?.orderLines?.length || 0
                }
                sort={getSortParams(params)}
                onUpdateListSettings={updateListSettings}
                pageInfo={{
                  hasNextPage: !disableNext(),
                  hasPreviousPage: !disablePrev()
                }}
                settings={settings}
                setListOrderLine={setListOrderLine}
                orderLineListAll={listOrderLine}
                currentData={currentData()}
                isCashSaleOrder={isCashSaleOrder}
                cashSaleFormProps={cashSaleFormProps}
              />
            </div>

            <BottomBarCreateOrder
              taxPercent={taxPercent}
              onAddItem={handleAddItems}
              activeTab={activeTab}
              onSaveDraft={handleOnSaveDraft}
              onSubmitOrder={handleOnSubmitOrder}
              deleteCount={listSelectDelete.length}
              onDelete={handleOnDelete}
              priceData={priceData}
              isDisableBtnSaveDraft={isDisabledSubmit}
              isDisableBtnCreateOrder={
                !listOrderLine?.length || isDisabledSubmit
              }
            />
          </Container>

          {/* List Modal dialog */}
          <DialogError
            onClose={() => {
              setVisibleDialogError(false);
              setPopUpContent(null);
            }}
            open={visibleDialogError}
            body={popUpContent}
          />

          <DialogConfirmChangeOrder
            loading={isDisabledSubmit}
            onClose={() => {
              setMode(null);
              handleCloseConfirm();
            }}
            open={openConfirmOrder}
            onOk={handleConfirmOrder}
            title={dataModalConfirm.title}
            content={dataModalConfirm.content}
            cancelText={intl.formatMessage({ defaultMessage: "กลับไป" })}
          />
          <DrawAddProductDomestic
            remainProductInOrderLinesCateg1={remainProductInOrderLinesCateg1}
            remainProductInOrderLines={remainProductInOrderLines}
            contract={dataContract?.contract}
            open={isPopupOpen}
            onClose={handleClosePopup}
            contractId={dataContract?.contract?.id}
            orderId={id}
            isReFetechData
            // refetchData={refetchCustomerOrderData}
            staffUpdate={STAFF_UPDATE.ADD_ORDER_DOMESTIC}
            sort={getSortParams(params)}
            onSort={handleSortListProduct}
            handleAddMoreData={handleAddMoreData}
            setVisibleDialogError={setVisibleDialogError}
            setPopUpContent={setPopUpContent}
          />

          <DialogConfirmDelete
            onConfirm={deleteOrderLines}
            onCancel={() => setOpenDelete(false)}
            open={openDelete}
            title={
              <span className={classes.titleDelete}>
                Delete item สินค้าที่เลือก
              </span>
            }
            content={
              <MyTypography variant={"body2"}>
                {intl.formatMessage({
                  defaultMessage:
                    "กรุณากด “ยืนยัน” เพื่อลบรายการสินค้าที่เลือก หรือกด “กลับไป” เพื่อปิดหน้าต่างนี้"
                })}
              </MyTypography>
            }
          />

          <DialogConfirmError
            open={dialogError}
            onConfirm={() => setDialogError(false)}
            onCancel={() => setDialogError(false)}
            errorSource={errorSource}
            errorOrders={errorOrders}
            errorItems={errorItems}
          />

          <DialogProcessing
            open={loadingDeleteDomesticOrderLines}
            description={"ระบบกำลังประมวลผล กรุณารอสักครู่"}
          />

          {isSuccessfully && (
            <SnackbarAlert
              data-testid="snackbarAlert"
              severity={isSuccessfully}
              open={!!isSuccessfully}
              onClose={() => setSuccessfully(null)}
              verticalCenter={true}
              anchorOrigin={{ horizontal: "center", vertical: "top" }}
            >
              <div className={classes.snackHeadTitle}>
                {mode === ModeUpdate.ApplyAll && (
                  <>
                    <MyTypography
                      variant="subtitle2"
                      style={{ color: "#ffffff", marginRight: "2px" }}
                    >
                      {intl.formatMessage({
                        defaultMessage: "APPLY ALL",
                        description: "dialog header"
                      })}
                    </MyTypography>
                    <MyTypography variant="body3" style={{ color: "#ffffff" }}>
                      {isSuccessfully === "success"
                        ? "ใช้กับ Item Details สำเร็จ"
                        : ""}
                    </MyTypography>
                  </>
                )}
                {mode === ModeUpdate.SaveDraft && (
                  <MyTypography variant="body3" style={{ color: "#ffffff" }}>
                    {isSuccessfully === "success"
                      ? "บันทึกฉบับร่าง สำเร็จ"
                      : "Fail to save draft"}
                  </MyTypography>
                )}
              </div>
            </SnackbarAlert>
          )}

          <Backdrop open={!!isSuccessfully} className={classes.backDrop} />
        </>
      ) : (
        <OrderProcessingView
          isCreateOrder
          orderProcessStatus={orderProcessStatus}
          onFailed={handleProcessCreateOrderFailed}
          errorCode={orderProcessError}
          code={errorCode}
        />
      )}
    </>
  );
};

export default CreateOrderDomesticView;
